<template>
	<div class="feedback-detail">
		<div class="row">
			<div class="label">反馈时间：</div>
			<div class="value">{{detail.createTime}}</div>
		</div>
		<div class="row">
			<div class="label">反馈内容：</div>
			<div class="value">{{detail.context}}</div>
		</div>
		<div class="row">
			<div class="label">反馈图片：</div>
			<div class="value">
				<div class="list">
					<img v-for="(pic, i) in getPics(detail)" v-lazy="pic" :key="pic" alt="" class="thumb" @click="onClickThumb(i)">
				</div>
			</div>
		</div>
		<div class="row">
			<div class="label">回复状态：</div>
			<div class="value">{{detail.statusText}}</div>
		</div>
		<div class="row" v-show="detail.hasReply">
			<div class="label">回复时间：</div>
			<div class="value">{{detail.replyTime}}</div>
		</div>
		<div class="row" v-show="detail.hasReply">
			<div class="label">回复内容：</div>
			<div class="value">{{detail.replyContext}}</div>
		</div>
	</div>
</template>

<script>
import { ImagePreview } from 'vant';

export default {
	name: 'FeedbackDetail',
	props: {
		detail: {
			type: Object,
			default() {
				return {
					createTime: '',
					context: '',
					pics: '',
					statusText: '',
					replyTime: '',
					replyContext: '',
					hasReply: false
				};
			}
		}
	},
	data() {
		return {
			previewVisible: false,
		};
	},
	methods: {
		getPics(detail) {
			let {pics = ''} = detail || {};
			let list = String(pics || '').split(',').filter(p => !!p);
			return list;
		},
		onClickThumb(i) {
			ImagePreview({
				images: this.getPics(this.detail),
				closeable: true,
				startPosition: i
			});
		}
	}
};
</script>

<style scoped lang="scss">
	.feedback-detail {
		background: #ffffff;
		padding: 10px 14px;
		border-radius: 12px;
		margin: 10px;
	}
	.row {
		display: flex;
		padding: 9px 0;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: rgba(0,0,0,0.7);
		line-height: 22px;
		.label {
			min-width: 80px;
			white-space: nowrap;
		}
		.value {
			flex: 1;
			color: #000000;
		}
	}
	.thumb {
		width: 48px;
		height: 48px;
		border-radius: 8px;
		margin-right: 10px;
	}
</style>
